import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { Success } from '../../components';

export const Confirmation = () => {
  const location = useLocation();
  // Page title
  useEffect(() => {
    const title = `Make a donation to cure childhood cancer - St. Jude Children's Research Hospital - payment confirmed`;
    document.title = `${title} - payment confirmed`;
  }, []);

  const dafEmbed = document.querySelector('.daf_wrap') as HTMLElement;

  useEffect(() => {
    if (dafEmbed && location.pathname?.includes('/confirmation')) {
      dafEmbed.setAttribute('style', 'visibility: hidden !important');
    }
  }, [dafEmbed, location.pathname]);

  return (
    <Box>
      <Success />
    </Box>
  );
};
